/**
 * get the workout name of the sessions
 * @param {*} sessions
 * @param {*} week
 * @param {*} order
 * @param {*} insideSession this is to detect if we have to iterate by sessions.session or only sessions
 * @returns
 */

export function getCurrentSessionWorkoutName(
  sessions = [],
  week = 1,
  order = 1,
  insideSession = false
) {
  let workoutName = undefined;

  const compareParams = insideSession
    ? (item) => item.session.order === order && item.session.week === week
    : (item) => item.order === order && item.week === week;

  const indexToUpdate = sessions.findIndex(compareParams);

  if (indexToUpdate >= 0 && indexToUpdate < sessions.length) {
    workoutName = insideSession
      ? sessions[indexToUpdate].session.workoutName
      : sessions[indexToUpdate].workoutName;
  }

  return workoutName;
}
